module.exports = "https://static.wagwalking.com/_next/static/images/how-wag-works-app-e1f60f2aa8935c26869f4d917ffac5a3.png";